module.exports = __webpack_public_path__ + "static/media/toelogic-5.def230fd.jpg";